// extracted by mini-css-extract-plugin
module.exports = {"container":"styles-module--container--3mhDs","menu":"styles-module--menu--2Ydrf","social":"styles-module--social--1r55-"};